import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'

export const CONFLUENCE_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  space: {
    type: GenericMappingType.KEYWORD,
    name: 'Space',
    description: 'Space the page belongs to',
    enumFromCollapseEsQuery: true,
    order: 0,
  },
  status: {
    type: GenericMappingType.KEYWORD,
    name: 'Status',
    description: 'Status of the page',
    enumFromCollapseEsQuery: true,
    order: 1,
  },
  version: {
    type: GenericMappingType.NUMBER,
    name: 'Version',
    description: 'Version number of the page',
    order: 2,
  },
  owner: {
    type: GenericMappingType.KEYWORD,
    name: 'Owner',
    description: 'Owner of the page',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  creator: {
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'Creator of the page',
    enumFromCollapseEsQuery: true,
    order: 4,
  },
  title: {
    type: GenericMappingType.KEYWORD,
    name: 'Title',
    description: 'Title of the page',
    order: 5,
  },
} satisfies GenericMappingByKey)
